import { render } from "./ServiceFomo.vue?vue&type=template&id=12bc74e9"
import script from "./ServiceFomo.vue?vue&type=script&lang=js"
export * from "./ServiceFomo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__